import React from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { DiscoveryOverview } from '../../../model/discovery/DiscoveryOverview';
import { ErrorToast, SuccessToast } from '../../../utils/toasters';
import { DiscoveryService } from '../DiscoveryService';

export interface IModalDiscoveryTokens {
    modalData: { showModal: boolean; company?: Partial<DiscoveryOverview> };
    setModalData: (args: any) => void;
    setChange: (args: any) => void;
    change: boolean;
}

export default function ModalDiscoveryTokens({ modalData, setModalData, setChange, change }: IModalDiscoveryTokens) {
    const editTokens = (companyId?: number) => {
        DiscoveryService.editCompanyDiscoveryTokens(companyId, {
            discoveryTokens: modalData?.company?.discoveryTokens,
            discoverySearchTokens: modalData?.company?.discoverySearchTokens,
        })
            .then(() => {
                SuccessToast('Successfully changed tokens');
            })
            .catch(err => ErrorToast(err));
    };
    return (
        <Modal
            show={modalData.showModal}
            onHide={() => setModalData((prev: any) => ({ ...prev, showModal: false }))}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalData?.company?.companyName} Company Tokens</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="mb-3">
                        <Col xs={12} md={6}>
                            <Form.Group controlId="discoverySearchTokens">
                                <Form.Label>Discovery Search Tokens</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="discoverySearchTokens"
                                    defaultValue={modalData?.company?.discoverySearchTokens}
                                    onChange={e =>
                                        setModalData((prev: any) => ({
                                            ...prev,
                                            company: {
                                                ...prev.company,
                                                discoverySearchTokens: e.target.value,
                                            },
                                        }))
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                            <Form.Group controlId="discoveryTokens">
                                <Form.Label>Discovery Profile Tokens</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="discoveryTokens"
                                    defaultValue={modalData?.company?.discoveryTokens}
                                    onChange={e =>
                                        setModalData((prev: any) => ({
                                            ...prev,
                                            company: {
                                                ...prev.company,
                                                discoveryTokens: e.target.value,
                                            },
                                        }))
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="outline-primary"
                    onClick={() => setModalData((prev: any) => ({ ...prev, showModal: false }))}
                >
                    Close
                </Button>
                <Button
                    onClick={() => {
                        setModalData((prev: any) => ({ ...prev, showModal: false }));
                        editTokens(modalData?.company?.companyId);
                        setChange(!change);
                    }}
                >
                    Edit
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
